module.exports = __webpack_public_path__ + "static/img/27.097b593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/27.png
// module id = Z7bJ
// module chunks = 0